// ─── Role Constants ────────────────────────────────────────────────────
// Mirror of backend roles. Single source of truth for the frontend.

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ORG_ADMIN: 'org_admin',
  FINANCE_MANAGER: 'finance_manager',
  ACCOUNTANT: 'accountant',
  APPROVER: 'approver',
  EMPLOYEE: 'employee',
  AUDITOR: 'auditor',
} as const;

export type RoleName = (typeof ROLES)[keyof typeof ROLES];

// ─── Role Display Names ───────────────────────────────────────────────

export const ROLE_DISPLAY_NAMES: Record<string, string> = {
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.ORG_ADMIN]: 'Organization Admin',
  [ROLES.FINANCE_MANAGER]: 'Finance Manager',
  [ROLES.ACCOUNTANT]: 'Accountant',
  [ROLES.APPROVER]: 'Approver',
  [ROLES.EMPLOYEE]: 'Employee',
  [ROLES.AUDITOR]: 'Auditor',
};

// ─── Role Hierarchy (higher = more senior) ────────────────────────────

export const ROLE_HIERARCHY: Record<string, number> = {
  [ROLES.SUPER_ADMIN]: 100,
  [ROLES.ORG_ADMIN]: 80,
  [ROLES.FINANCE_MANAGER]: 60,
  [ROLES.APPROVER]: 50,
  [ROLES.ACCOUNTANT]: 40,
  [ROLES.AUDITOR]: 30,
  [ROLES.EMPLOYEE]: 20,
};

// ─── All Role Names ───────────────────────────────────────────────────

export const ALL_ROLE_NAMES: readonly string[] = Object.values(ROLES);
